// extracted by mini-css-extract-plugin
export default {"closeButton":"abtasty-qa-assistant__CloseButton-module__closeButton___xbNAF","tooltip":"abtasty-qa-assistant__CloseButton-module__tooltip___CjGQn"};